import React from 'react';
import styles from './Resources.module.css';

const Resources = () => {
  return (
    <div className={styles.resourcesPage}>
      <div className={styles.resourcesTitleContainer}>
        <h1 className={styles.resourcesPageTitle}>Resources</h1>
      </div>
      <div className={styles.resourcesContainer}>
        <div className={styles.resourcesCardGrid}>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Curriculum Resources</h3>
            <p className={styles.resourceCardDesc}>Access to comprehensive curriculum materials, lesson plans, and educational resources.</p>
            <button className={styles.resourceCardBtn}>Browse Resources</button>
          </div>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Assessment Tools</h3>
            <p className={styles.resourceCardDesc}>Create and manage assessments, track student progress, and generate reports.</p>
            <button className={styles.resourceCardBtn}>Assessment Center</button>
          </div>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Black History Library</h3>
            <p className={styles.resourceCardDesc}>Explore our extensive collection of Black History resources, biographies, and historical documents.</p>
            <button className={styles.resourceCardBtn}>Explore Library</button>
          </div>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Interactive Activities</h3>
            <p className={styles.resourceCardDesc}>Engage students with interactive activities, games, and multimedia content.</p>
            <button className={styles.resourceCardBtn}>View Activities</button>
          </div>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Professional Development</h3>
            <p className={styles.resourceCardDesc}>Access training materials and professional development resources for educators.</p>
            <button className={styles.resourceCardBtn}>Training Center</button>
          </div>
          <div className={styles.resourceCard}>
            <h3 className={styles.resourceCardTitle}>Student Resources</h3>
            <p className={styles.resourceCardDesc}>Direct students to age-appropriate learning materials and study resources.</p>
            <button className={styles.resourceCardBtn}>Student Portal</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources; 